import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserData } from 'src/app/models/user.model';
import { UserProvider } from 'src/app/services/providers/user-provider.ts/user-provider';

export const unauthGuard: CanActivateFn = async (route, state) => {
  const userProvider = inject(UserProvider);
  const router = inject(Router);
  const currentUser: UserData | null = userProvider.getCurrentUserData;

  if (!currentUser) {
    return true;
  }

  if (currentUser.state.toLowerCase() === 'valid' && currentUser.accessToken.token) {

    router.navigateByUrl('/dashboard');
    return false;
  }

  if (currentUser.state.toLowerCase() === 'registrationrequired') {
    router.navigateByUrl('/request-registration');
  }

  return true;
};
